<template>
  <zj-layout-container>
    <zj-layout-header style="padding:0rem 0px 0px 0px;">
      <div class="zj-button-bar">
        <el-upload
          style="float:right;margin-left:1rem;"
          :action="CNF('api.base_url') + '/jk/common-api/common/uploadFiles'"
          list-type="picture"
          accept=".pdf, .doc, .docx, .xls, .jpg, .jpeg, .bmp, .png"
          :show-file-list="false"
          :before-upload="beforeupload"
          :on-success="uploadsuccess"
          :on-progress="uploadProgress"
          :on-error="uploadError"
        >
          <!-- :data="uploadData" -->
          <el-button size="mini" style="width:8rem"  v-if="!IsEdit">上传</el-button>
        </el-upload>
      </div>
    </zj-layout-header>
    <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" height="100%"
        v-loading="loading" :element-loading-text="loadingText">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="attatchName" label="附件名称" align="center"></el-table-column>
        <el-table-column prop="attatchFormat" label="格式" align="center"></el-table-column>
        <el-table-column prop="uploadDate" label="上传时间" align="center"></el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-link
              v-bind:href="scope.row.downloadUrl"
              class="el-button el-button--text el-button--small download-link"
              target="_blank"
              :underline="false"
            >下载</el-link>
            <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small" v-if="!IsEdit">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </zj-layout-main>
    <zj-layout-footer style="padding-bottom: 0rem;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { list, save, remove } from "@/api/src/emergency_plan_attach";
export default {
  name: "ZjAttachList",
  controller: "UI",
  action: "AttachList",
  props: {
    planId: String
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      fileList: [],
      IsEdit: false
    };
  },
  created: function() {
    if (this.$route.query.id != null) {
      this.planId = this.$route.query.id;
    }
    this.IsEdit = this.$route.query.type == "edit" ? false : true;
    this.search();
  },
  methods: {
    beforeupload: function() {
      this.loading = true;
      this.loadingText = '上传中... 0%';
    },
    uploadsuccess: function(obj) {
      this.loading = false;
      this.addPlanFile(obj);
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = '上传中... ' + parseInt(e.percent) + '%';
    },
    addPlanFile(obj) {
      console.log(obj)
      if(obj.code == 0){
        this.loading = true;
        this.loadingText = '保存中...';
        let { data } = obj
        save({
          attatchFormat:data.type ,
          attatchName:data.filename ,
          downloadUrl: data.uploadSrc,
          planId: this.planId,
          uploadDate:data.uploadTime,
        }) 
        .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "上传成功！" : "上传失败！"
            });
            this.loading = false;
            this.search();
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }else{
        this.$message({
          type: "error",
          message: data.msg
        });
         this.loading = false;
      }
    },
    search() {
      let searchInfo = {
        size: this.pageSize,
        current: this.currentPage,
        planId: this.planId
      };
      this.loading = true;
      this.loadingText = '加载中...';
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '删除中...';
          remove({idList: row.id})
            .then(r => {
              r = r.data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.loading = false;
              this.search();
            })
            .catch(e => {
              console.error(e);
              this.loading = false;
            });
        });
    },
  }
};
</script>